<p>client-subscription works!</p>
